import moment from "moment";
import { TStoreAvailability, TStores } from "./types";
import clsx from 'clsx';

export const getWithInByText = (avail: TStoreAvailability) => {
  switch (avail.bucket) {
    case '00:45:00':
    case '02:00:00':
    case '04:00:00':
    case '06:00:00':
    case '08:00:00':
      return 'Within';
    default:
      return '';
  }
}

/*condition need to relook*/
export const getDisplayLabel = (label: string, isReplaceLabel: boolean) => {
  const labelName = label?.replaceAll(" ", "").trim() || "";
  switch (labelName) {
    case 'SameDay':
      return isReplaceLabel ? 'Today' : '';
    case 'NextBusinessDay':
      return 'Today';
    default:
      return label;
  }
};

export const getOrderMessage = (avail: TStoreAvailability, isTooltip: boolean) => {
  console.log('avail order msg ', avail);

  if (avail?.deliveryDay !== "Same Day" && avail?.deliveryDay !== "Today") {
    return <span className="underline">{`Order by ${avail.moment.format('ddd, MMM D @ h:mma')}`}</span>;
  }
  return (
    <>
      <span className="underline">{isTooltip ? '' : `Order by ${avail.moment.format('h:mma')} Today`}</span>{" "}
    </>
  );
};


export const getDeliveryMessage = (
  avail: TStoreAvailability,
  isMobileTruckUser: boolean,
  handleIsMobileTruckUser: (avail: TStoreAvailability) => void,
  deliveredBy: string,
  isTooltip: boolean
) => {
  if (avail.deliveryDay !== "Same Day") {
    return <span className="cell">{avail?.deliveredByDesc}</span>
  }

  return (
    <>
      <span className="underline cell">{isTooltip ? '' : deliveredBy}</span>
      <span className='cell'>{`${getStoreTime(avail.storeTime)}`}</span>
      <span
        onClick={() => handleIsMobileTruckUser(avail)}
        className={clsx("underline cell", { isMobile: isMobileTruckUser })}
      >
        {getDisplayLabel(avail.bucket, true)}
      </span>
    </>
  );
};

export const bucketParser = (availDuration: string) => {
  switch (availDuration) {
    case '00:45:00':
    case '02:00:00':
    case '04:00:00':
    case '06:00:00':
    case '08:00:00':
    case 'Immediately':
    case 'Same Day':
      return 'Today';
    default:
      return availDuration;
  }
}

export const getBucketName = (avail: TStoreAvailability, isFullView?: boolean) => {
  switch (avail.bucket) {
    case '00:45:00':
      return '45 Minutes';
    case '02:00:00':
      return '2 Hours';
    case '04:00:00':
      return '4 Hours';
    case '06:00:00':
      return '6 Hours';
    case '08:00:00':
      return '8 Hours';
    default:
      return isFullView ? `${avail.bucket} -` : avail.bucket;
  }
}

export const getDeliveredDay = (avail: TStoreAvailability) => {
  const now = moment();
  const endOfDay = moment().endOf('day');

  const diff = endOfDay.diff(now, 'minutes');
  const addedMinutes = moment().add(avail.validForMin, 'minutes');
  const daysDiff = moment(addedMinutes.format('YYYY-MM-DD')).diff(now.format('YYYY-MM-DD'), 'days');

  if (avail.validForMin >= diff) {
    return `Next ${daysDiff > 1 ? daysDiff : ''} Business Day${daysDiff > 1 ? 's' : ''}`;
  } else {
    return 'Today'
  }
}


export const getStoreTime = (time: string) => {
  const _time = time.split(':');
  const hour = Number(_time[0]);
  const min = Number(_time[1]);

  const today = moment().hour(hour).minute(min);
  return today.format('h:mma');
}

export const getTodayOrDate = (avail: TStoreAvailability) => {
  if (avail.validForMin < 0) {
    return "Order Now";
  }

  const now = moment();
  if (now.format('YYYY-MM-DD') === moment(avail.moment).format('YYYY-MM-DD')) {
    return `${moment(avail.moment).format('h:mma')} Today`;
  }
  return moment(avail.moment).format('ddd, MMM D @ h:mma');
}


export const getStoreAddress = (storeNumber: string, stores: TStores) => {
  const address = stores.find((store) => store.storeNum === storeNumber)?.address || '';

  return address.toLocaleLowerCase();
}
